import { render, staticRenderFns } from "./AdditionInfo.vue?vue&type=template&id=dd925bc4&scoped=true&"
import script from "./AdditionInfo.vue?vue&type=script&lang=js&"
export * from "./AdditionInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdditionInfo.vue?vue&type=style&index=0&id=dd925bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd925bc4",
  null
  
)

export default component.exports